export type UserGroup = 'wavin' | 'jablotron' | 'normal';

const WAVIN_DOMAINS = ['wavin.com', 'orbia.com'] as const;
const JABLOTRON_DOMAINS = ['jablotron.cz'] as const;

function getEmailDomain(email: string): string | undefined {
  const atIndex = email.lastIndexOf('@');
  if (atIndex < 0 || atIndex === email.length - 1) {
    return undefined;
  }
  return email.slice(atIndex + 1).toLowerCase();
}

export function resolveUserGroup(email: string): UserGroup {
  const domain = getEmailDomain(email.trim());
  if (!domain) {
    return 'normal';
  }

  if (WAVIN_DOMAINS.some((wavinDomain) => domain === wavinDomain)) {
    return 'wavin';
  }

  if (JABLOTRON_DOMAINS.some((jablotronDomain) => domain === jablotronDomain)) {
    return 'jablotron';
  }

  return 'normal';
}
